
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe11 as ObiHydraulicPipe11Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-11.js';
 
 
 

 
 export const ObiHydraulicPipe11 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-11',
   elementClass: ObiHydraulicPipe11Element,
   events: {
     
   }
  });
 
 